import React, { Component } from 'react';
import Helmet from "react-helmet";
import { lang } from '../../il8n/lang';
import { connect } from 'react-redux';
import './WhereToBuy.css';
import { toggleInterstitial } from '../../Actions/Index';
import { mapATGLoc } from '../../utils';

/**
 * Where to Buy
 * @constructor
 */

class WhereToBuy extends Component {
  render() {
    return (
      <div className='wrap'>
        <div className='retailers'>
          <div className="wtb_header">
            <h2>{lang.home.sections.retailers.header} </h2>
          </div>
          <div className='retailers-list'>
            {lang.home.sections.retailers.retailers.map((retailer, index) => (
              <div className={`retailer retailer_${mapATGLoc()}`} key={`retailers___${index}`}>
                <a  target='_blank' rel='noopener noreferrer' onClick={() => {
                  if(retailer.href !== ''){
                    this.props.dispatch(toggleInterstitial(true, retailer.href))
                  }
                }}>
                  <img className={`retailer-img`} id={`${retailer.id}`} src={retailer.img} alt={retailer.name} />
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { lang: state.lang };
}

export default connect(mapStateToProps)(WhereToBuy);
